module.exports = __webpack_public_path__ + "img/ipx2.dc3c9b86.png";